import { cn } from '@mint-lib/tw-utils';

import './voiceAnimation.css';

type Props = { isActive: boolean };

const AnimatedVoice = ({ isActive }: Props) => {
  const fiveBars = [0, 1, 2, 3, 4];
  const voiceAnimation = (index: number) => {
    return `voice-wave-smaller 1s infinite ease-in-out ${index * 0.15}s`;
  };

  return (
    <div
      className={cn(
        'relative z-3 flex flex-row items-center justify-center',
        'h-5 w-5 gap-[2.4px]',
      )}
    >
      {fiveBars.map((value) => (
        <div
          key={value}
          aria-label="voice-animation"
          className={cn(
            'w-0.5 rounded-[2.4px] bg-text-primary',
            isActive ? 'h-2' : 'h-1',
          )}
          style={{
            animation: isActive ? voiceAnimation(value) : 'none',
          }}
        />
      ))}
    </div>
  );
};

export default AnimatedVoice;
